import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { configData } from "../Navbar/config";
import "../BreadCrumb/BreadCrumb.css";
import { navigationTree } from "../Sidebar/Service";
import { useAuth } from "../../authContext/AuthContext";
import profileIcon from "../../common/assets/images/profile-user.png";

const Breadcrumb = ({ sidebarOpen }) => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const { userEmail } = useAuth();

  if (location.pathname === "/") return null;

  // Helper to find breadcrumb trail - now matches any segment, not just last
  const findBreadcrumbTrail = (items, target, trail = []) => {
    for (const item of items) {
      const newTrail = [...trail];

      if (item.children) {
        const parentTrail = item.main_Router
          ? [
              ...newTrail,
              {
                name: item.main_Router,
                path: item.path ? `/${item.path}` : null,
                isMain: true,
              },
            ]
          : [...newTrail];

        // Check direct children
        const childMatch = item.children.find(
          (child) => child.path?.toLowerCase() === target?.toLowerCase()
        );

        if (childMatch) {
          return [
            ...parentTrail,
            { 
              name: childMatch.name, 
              path: `/${childMatch.path}`,
            },
          ];
        }

        // Recursive search
        for (const child of item.children) {
          if (child.children) {
            const result = findBreadcrumbTrail(
              [{ ...child, main_Router: null }],
              target,
              parentTrail.concat({
                name: child.name,
                path: child.path ? `/${child.path}` : null,
              })
            );
            if (result.length) return result;
          }
        }
      }

      if (item.path?.toLowerCase() === target?.toLowerCase()) {
        return [
          ...newTrail,
          { name: item.name, path: `/${item.path}`, isMain: false },
        ];
      }
    }
    return [];
  };

  const getBreadcrumbTrail = (segments) => {
    if (segments.length === 0) return [];
    
    // Try to find a match for any segment (not just the last one)
    for (const segment of segments) {
      const trail = findBreadcrumbTrail(configData, segment);
      if (trail.length > 0) {
        return trail;
      }
    }
    
    // If no match found, try to find parent route
    // For dynamic routes like /Review-Enhance-Workflow/1381372
    // Try matching the parent path
    for (let i = segments.length - 1; i >= 0; i--) {
      const trail = findBreadcrumbTrail(configData, segments[i]);
      if (trail.length > 0) {
        return trail;
      }
    }
    
    return [];
  };

  const breadcrumbs = getBreadcrumbTrail(pathSegments);
  
  // Check if current page is Review-Enhance-Workflow or its child
  const isReviewEnhance = pathSegments.some(
    seg => seg.toLowerCase() === "review-enhance-workflow"
  );

  return (
    <nav aria-label="breadcrumb" className="breadcrumb-wrapper">
      <ol className="breadcrumb d-flex align-items-center">
        <Link className="breadcrumb-item" to="/">
          Home
        </Link>

        {breadcrumbs.length > 0 && <span className="mx-2">{">"}</span>}

        {breadcrumbs.map((breadcrumb, index) => {
          const isCodeEnhance = breadcrumb.name === "Code Enhance";
          const isLast = index === breadcrumbs.length - 1;
          const shouldBeClickable = !isLast && !(isCodeEnhance && !isReviewEnhance);

          return (
            <React.Fragment key={index}>
              {shouldBeClickable && breadcrumb.path ? (
                <Link 
                  style={{ cursor: "pointer" }} 
                  className="breadcrumb-item" 
                  to={breadcrumb.path}
                >
                  {breadcrumb.name}
                </Link>
              ) : (
                <span className="breadcrumb-item text-muted">
                  {breadcrumb.name}
                </span>
              )}
              {index < breadcrumbs.length - 1 && (
                <span className="mx-2">{">"}</span>
              )}
            </React.Fragment>
          );
        })}
        
        {/* Add dynamic detail page name if it's a number */}
        {pathSegments.length > 0 && !isNaN(pathSegments[pathSegments.length - 1]) && (
          <>
            <span className="mx-2">{">"}</span>
            <span className="breadcrumb-item text-muted">
              Details {pathSegments[pathSegments.length - 1]}
            </span>
          </>
        )}
      </ol>

      {/* Profile Section */}
       <div className="d-flex gap-2 align-items-center">
        <img src={profileIcon} alt="profile" style={{ height: "24px" }} />
        <span
          style={{
            marginRight: sidebarOpen ? "225px" : "125px",
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          {userEmail}
        </span>
      </div>
    </nav>
  );
};
 
export default Breadcrumb;